import cartFunctions from "./cart-functions";
import functions from "./functions";

function quantityChange(buttonElement){

    let qty = buttonElement.closest('[data-quantity]').find('[data-quantity-input]');
    let val = parseFloat(qty.val());
    let max = parseFloat(qty.attr('max'));
    let min = parseFloat(qty.attr('min'));
    let step = parseFloat(qty.attr('step'));

    if (buttonElement.val() === "+") {

        if (functions.checkPage('product-page')) {
            buttonElement.siblings('[data-quantity-down]').removeClass('disabled');
        }


        if (max && (max <= val)) {

            qty.val(max);

        } else {

            qty.val(val + step);

        }

        if (qty.val() == max) {
            buttonElement.addClass('disabled');
        }


    } else {
        if (val <= 2 && functions.checkPage('product-page')) {

            buttonElement.addClass('disabled');
        }


        if (min && (min >= val)) {

            qty.val(min);

        } else if (val > 1) {

            qty.val(val - step);

        }

        if (qty.val() < max) {
            buttonElement.siblings('[data-quantity-up]').removeClass('disabled');
        }

    }

}

function variationToggleActive(){

    $('.variations input:checked').parent('.variations__option').addClass('active');

    $('main').on('change', '.variations input', function (){
        let wrapper = $(this).closest('.variations');

        $(wrapper).find('.variations__option').removeClass('active');
        $(this).parent('.variations__option').addClass('active');

    });

}


function init(){

    variationToggleActive();

    $('main').on('click', '[data-quantity-up], [data-quantity-down]', function (e){
        if (!$(this).hasClass('disabled')) {

            quantityChange($(this));

            if (functions.checkPage('cart-page')) {
                $('[data-cart-update]').prop("disabled", false).trigger('click');
                $('.woocommerce-cart-form .cart_item :input').trigger('change');
            }
        }
    });

    $('header').on('click', '[data-quantity-up], [data-quantity-down]', function (e){
        if (!$(this).hasClass('disabled')) {
            quantityChange($(this));
            cartFunctions.changeCartQuantity();
        }
    });
}

export default {init, quantityChange};


// WEBPACK FOOTER //
// ./src/scripts/quantity-input.js